var _defs, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3b82f6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 2,
    floodColor: "#3b82f6",
    floodOpacity: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 10,
    fill: "url(#gradient1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;14;10",
    dur: "1.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 0,
    r: 10,
    fill: "url(#gradient1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;14;10",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 0,
    r: 10,
    fill: "url(#gradient1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;14;10",
    dur: "2.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 0,
    stroke: "#93c5fd",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 0,
    x2: 80,
    y2: 0,
    stroke: "#93c5fd",
    strokeWidth: 2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 90,
    fontFamily: "'Segoe UI Black', 'Poppins', sans-serif",
    fontSize: 52,
    fontWeight: 900,
    fill: "url(#gradient1)",
    letterSpacing: 2,
    filter: "url(#softGlow)"
  }, "\n    NEXUS BUILD\n    ", /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0,0; 0,-3; 0,0",
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 130,
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 18,
    fill: "#64748b",
    fontWeight: 500
  }, "\n    Create \u2022 Connect \u2022 Code\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.6;1",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner4);
export default __webpack_public_path__ + "static/media/Partner4.17114c8ffd9b163531ed8a965224b40f.svg";
export { ForwardRef as ReactComponent };